export default {
  headline: 'Notification channels',
  subheadline: 'Setup your notification channels by accessing one of them',
  headerType: 'Channel type',
};
